import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { Router } from "../../../utilities/router";
import { GRAPHQL_TYPE_PERSON, GRAPHQL_TYPE_ENTITY, Person, Entity, ClaimRequest } from "@radivision/graphql";
import { UserRequestType } from "@radivision/graphql/lib/ts/graphql/user-request-type";
import { SVG } from "../../../component-configuration/svgs";
import { CLAIM_MODAL_ID } from "./claim-dropmenu-modal";
import { AUTHENTICATION_MODAL_ID } from "../../../redux/authentication/constants";
import { isOwner } from "../../../utilities/is-owner";

interface ComponentProps {
  subject: Person | Entity;
  onChangeModalTitle: (s: string) => void;
}

interface MapStateProps {
  user: Person;
}

type Props = ComponentProps & MapStateProps;

export const Component = (props: Props) => {
  const { user, subject, onChangeModalTitle } = props;
  const isPerson = subject?.__typename === GRAPHQL_TYPE_PERSON;
  const isCompany = subject?.__typename === GRAPHQL_TYPE_ENTITY;
  const owner = isOwner(subject, user);
  const showMoreMenu = !owner && ((isPerson && !user) || isCompany) && subject?.isClaimable;

  if (!showMoreMenu) {
    return null;
  }

  return (
    <>
      <a
        className="more-menu-toggle dropdown-toggle arrow-menu"
        href="#"
        id="more-menu-dropdown"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {SVG.dots}
      </a>
      {owner && user ? null : (
        <div className="dropdown-menu more-menu" aria-labelledby="more-menu-dropdown-list">
          <a className="dropdown-item" onClick={() => Router.to("support", undefined, "report-an-issue")}>
            Report an issue
          </a>

          {isCompany ? (
            <a
              className="dropdown-item"
              data-toggle="modal"
              data-target={`#${
                !user
                  ? AUTHENTICATION_MODAL_ID
                  : user &&
                    user.requests !== undefined &&
                    user.requests !== null &&
                    user.requests.find((value: UserRequestType) => {
                      return (value as ClaimRequest).item && (value as ClaimRequest).item.id === subject?.id;
                    })
                  ? "avoidMultipleClaim"
                  : CLAIM_MODAL_ID
              }`}
              onClick={() => onChangeModalTitle(`Welcome To Radivision`)}
            >
              Claim company
            </a>
          ) : (
            <a
              className="dropdown-item"
              data-toggle="modal"
              data-target={`#${CLAIM_MODAL_ID}`}
              onClick={() => onChangeModalTitle(`Welcome To Radivision`)}
            >
              Claim Profile
            </a>
          )}
        </div>
      )}
    </>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

export const HeaderMoreMenu = connect(mapState)(Component);
